import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import guid from '@/shared/utils/guid';
import messages from './filterMessages';
import UserSearchWithoutInjectIntl from '../../input/UserSearchWithoutInjectIntl';

class UserFilter extends Component {
  state = {
    value: '',
  };

  componentDidMount() {
    const { initialValue } = this.props;
    this.setState(state => ({
      ...state,
      value: initialValue || '',
    }));
  }

  handleClear() {
    this.setState(state => ({
      ...state,
      value: '',
    }));
  }

  handleInputChange(user) {
    const { onFilter, hideFilterButton } = this.props;
    const newValue = user?.id || '';

    this.setState({ value: newValue }, () => {
      // In multi-filter mode, notify parent of the change
      if (hideFilterButton) {
        onFilter({ items: newValue ? [newValue] : [] });
      }
    });
  }

  render() {
    const { value } = this.state;
    const { onFilter, isFiltered, intl, withUnassigned, hideFilterButton } = this.props;

    return (
      <div style={{ width: hideFilterButton ? '100%' : '400px' }}>
        <UserSearchWithoutInjectIntl
          onChange={user => this.handleInputChange(user)}
          value={value}
          hideClearButton
          withUnassigned={withUnassigned}
          unassignedId={guid.empty}
          small
          intl={intl}
        />

        {!hideFilterButton && (
          <button
            type="button"
            className="btn btn-inverse btn-block btn-sm margin10T"
            onClick={() => onFilter({ items: [value] })}
          >
            {intl.formatMessage(messages.Filter)}
          </button>
        )}
        {isFiltered && !hideFilterButton && (
          <button
            type="button"
            className="btn btn-default btn-sm margin10T"
            onClick={() => onFilter({ items: [] })}
          >
            <i className="fa fa-times" />
            &nbsp;
            <span>{intl.formatMessage(messages.ClearFilter)}</span>
          </button>
        )}
      </div>
    );
  }

  static propTypes = {
    initialValue: PropTypes.string,
    /** Function to execute when a value has been entered and search has been requested */
    onFilter: PropTypes.func.isRequired,
    /** Boolean indicating whether a value is currently being filtered. Used for displaying a clear filter button  */
    isFiltered: PropTypes.bool,
    intl: intlShape.isRequired,
    /** Whether to include an "Unassigned" option in the user search */
    withUnassigned: PropTypes.bool,
    /** Whether to hide the filter button and auto-apply on selection */
    hideFilterButton: PropTypes.bool,
  };

  static defaultProps = {
    initialValue: '',
    isFiltered: false,
    withUnassigned: true,
    hideFilterButton: false,
  };
}

export default UserFilter;
